import MetisSVG from '@/assets/images/metis.svg';

import { goated } from '@/common-helpers/goatChain';
import { andromeda } from '@/common-helpers/metisChain';
import BangSvg from '@/assets/images/bang_logo.svg';
import GoatSVG from '@/assets/images/goat_logo.svg';
import { mainnet as mainnetChain, sepolia } from 'viem/chains';
import { metisSepolia } from '@/common-helpers/metisSepoliachain';

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export enum ChainId {
    testnet = sepolia.id,
    metisTestnet = metisSepolia.id,
    mainnet = mainnetChain.id,
    metisMainnet = andromeda.id,
    goatedMainnet = goated.id,
}

export const DefaultChainId = ChainId.metisMainnet;

export const SupportChainIDs = [
    ChainId.testnet,
    ChainId.metisTestnet,
    ChainId.mainnet,
    ChainId.metisMainnet,
    ChainId.goatedMainnet,
];

// export const BridgeCostApi = {
//     [Env.test]: 'https://api-dac.metis.io/test/service/api/bridge/gasinmetis',
//     [Env.mainnet]: 'https://api-dac.metis.io/service/api/bridge/gasinmetis',
// };

export const ToChainIdPair = {
    [ChainId.mainnet]: ChainId.metisMainnet,
    [ChainId.metisMainnet]: ChainId.mainnet,
    [ChainId.testnet]: ChainId.metisTestnet,
    [ChainId.metisTestnet]: ChainId.testnet,
};

export const NETWORK_CONFIG = {
    [ChainId.testnet]: {
        name: sepolia.name,
        scanLable: 'Sepolia Scan',
        explore: sepolia.blockExplorers?.default?.url,
        img: require('../assets/images/eth_logo.png'),
        nativeCurrency: sepolia.nativeCurrency,
    },
    [ChainId.metisTestnet]: {
        name: metisSepolia.name,
        scanLable: 'Metis(Sepolia)-explorer',
        explore: metisSepolia.blockExplorers?.default?.url,
        img: MetisSVG,
        nativeCurrency: metisSepolia.nativeCurrency,
    },
    [ChainId.mainnet]: {
        name: mainnetChain.name,
        scanLable: 'Etherscan',
        explore: mainnetChain.blockExplorers?.default?.url,
        img: require('../assets/images/eth_logo.png'),
        nativeCurrency: mainnetChain.nativeCurrency,
    },
    [ChainId.metisMainnet]: {
        name: andromeda.name,
        scanLable: 'Andromeda Explorer',
        explore: andromeda.blockExplorers?.default?.url,
        img: MetisSVG,
        nativeCurrency: andromeda.nativeCurrency,
    },
    [ChainId.goatedMainnet]: {
        name: goated.name,
        scanLable: 'Goat Network Explorer',
        explore: goated.blockExplorers?.default?.url,
        img: GoatSVG,
        nativeCurrency: goated.nativeCurrency,
    },
};

export const GAS_LIMIT = 0.1;

export enum Token {
    metis = 'metis',
    eth = 'eth',
    usdc = 'usdc',
    usdt = 'usdt',
    wow = 'wow',
    link = 'link',
    aave = 'aave',
    sushi = 'sushi',

    dai = 'dai',

    wbtc = 'wbtc',
    busd = 'busd',

    wsteth = 'wsteth',
    acp = 'acp',
    bang = 'bang',
}

export const Tokens = {
    [Token.eth]: {
        [ChainId.mainnet]: {
            name: 'ETH',
            symbol: 'ETH',
            address: '',
            img: require('../assets/images/eth_logo.png'),
            decimals: 18,
        },
        [ChainId.testnet]: {
            name: 'ETH',
            symbol: 'ETH',
            address: '',
            img: require('../assets/images/eth_logo.png'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'ETH',
            symbol: 'ETH',
            address: '0x420000000000000000000000000000000000000A',
            img: require('../assets/images/eth_logo.png'),
            decimals: 18,
        },
        [ChainId.metisTestnet]: {
            name: 'ETH',
            symbol: 'ETH',
            address: '0x420000000000000000000000000000000000000A',
            img: require('../assets/images/eth_logo.png'),
            decimals: 18,
        },
    },

    [Token.metis]: {
        [ChainId.mainnet]: {
            name: 'Metis Token',
            symbol: 'METIS',
            address: '0x9E32b13ce7f2E80A01932B42553652E053D6ed8e',
            img: MetisSVG,
            decimals: 18,
        },
        [ChainId.testnet]: {
            name: 'Metis Token',
            symbol: 'METIS',
            address: '0x7f49160EB9BB068101d445fe77E17ecDb37D0B47',
            img: MetisSVG,
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'Metis Token',
            symbol: 'METIS',
            address: '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
            img: MetisSVG,
            decimals: 18,
        },
        [ChainId.metisTestnet]: {
            name: 'Metis Token',
            symbol: 'METIS',
            address: '0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
            img: MetisSVG,
            decimals: 18,
        },
    },
    [Token.usdc]: {
        [ChainId.mainnet]: {
            name: 'USDC Token',
            symbol: 'USDC',
            address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            img: require('../assets/images/usdc_logo.png'),
            decimals: 6,
        },

        [ChainId.metisMainnet]: {
            name: 'USDC Token',
            symbol: 'm.USDC',
            address: '0xea32a96608495e54156ae48931a7c20f0dcc1a21',
            img: require('../assets/images/usdc_logo.png'),
            decimals: 6,
        },
    },
    [Token.usdt]: {
        [ChainId.mainnet]: {
            name: 'USDT Token',
            symbol: 'USDT',
            address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            img: require('../assets/images/usdt_logo.png'),
            decimals: 6,
        },

        [ChainId.metisMainnet]: {
            name: 'USDT Token',
            symbol: 'm.USDT',
            address: '0xbb06dca3ae6887fabf931640f67cab3e3a16f4dc',
            img: require('../assets/images/usdt_logo.png'),
            decimals: 6,
        },
    },
    [Token.wow]: {
        [ChainId.mainnet]: {
            name: 'WOW Token',
            symbol: 'WOW',
            address: '0x3405a1bd46b85c5c029483fbecf2f3e611026e45',
            img: require('../assets/images/wow_logo.png'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'WOW Token',
            symbol: 'm.WOW',
            address: '0x5ce34d9abe4bf239cbc08b89287c87f4cd6d80b7',
            img: require('../assets/images/wow_logo.png'),
            decimals: 18,
        },
    },
    [Token.link]: {
        [ChainId.mainnet]: {
            name: 'LINK Token',
            symbol: 'LINK',
            address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
            img: require('../assets/images/link_logo.png'),
            decimals: 18,
        },

        [ChainId.metisMainnet]: {
            name: 'LINK Token',
            symbol: 'm.LINK',
            address: '0xf5f66d5daa89c090a7afa10e6c1553b2887a9a33',
            img: require('../assets/images/link_logo.png'),
        },
    },
    [Token.aave]: {
        [ChainId.mainnet]: {
            name: 'AAVE Token',
            symbol: 'AAVE',
            address: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
            img: require('../assets/images/aave_logo.png'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'AAVE Token',
            symbol: 'm.AAVE',
            address: '0xd1f0a4e5444eed0fbcd6624dcef7ef33043e6168',
            img: require('../assets/images/aave_logo.png'),
            decimals: 18,
        },
    },

    [Token.dai]: {
        [ChainId.mainnet]: {
            name: 'DAI Token',
            symbol: 'DAI',
            address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
            img: require('../assets/images/dai_logo.png'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'DAI Token',
            symbol: 'm.DAI',
            address: '0x4c078361fc9bbb78df910800a991c7c3dd2f6ce0',
            img: require('../assets/images/dai_logo.png'),
            decimals: 18,
        },
    },
    [Token.sushi]: {
        [ChainId.mainnet]: {
            name: 'Sushi Token',
            symbol: 'Sushi',
            address: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
            img: 'https://raw.githubusercontent.com/MetisProtocol/metis-bridge-resources/master/tokens/SUSHI/logo.png',
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'Sushi Token',
            symbol: 'm.SUSHI',
            address: '0x17ee7e4da37b01fc1bcc908fa63df343f23b4b7c',
            img: 'https://raw.githubusercontent.com/MetisProtocol/metis-bridge-resources/master/tokens/SUSHI/logo.png',
            decimals: 18,
        },
    },
    [Token.busd]: {
        [ChainId.mainnet]: {
            name: 'BUSD Token',
            symbol: 'BUSD',
            address: '0x4fabb145d64652a948d72533023f6e7a623c7c53',
            img: 'https://raw.githubusercontent.com/MetisProtocol/metis-bridge-resources/master/tokens/BUSD/logo.png',
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'BUSD Token',
            symbol: 'm.BUSD',
            address: '0xb809cda0c2f79f43248c32b5dcb09d5cd26bbf10',
            img: 'https://raw.githubusercontent.com/MetisProtocol/metis-bridge-resources/master/tokens/BUSD/logo.png',
            decimals: 18,
        },
    },

    [Token.wbtc]: {
        [ChainId.mainnet]: {
            name: 'WBTC Token',
            symbol: 'WBTC',
            address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
            img: require('../assets/images/wbtc_logo.png'),
            decimals: 8,
        },
        [ChainId.metisMainnet]: {
            name: 'WBTC Token',
            symbol: 'm.WBTC',
            address: '0x433e43047b95cb83517abd7c9978bdf7005e9938',
            img: require('../assets/images/wbtc_logo.png'),
            decimals: 8,
        },
    },
    [Token.wsteth]: {
        [ChainId.mainnet]: {
            name: 'Wrapped liquid staked Ether',
            symbol: 'wstETH',
            address: '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
            img: require('../assets/images/wsteth.webp'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            name: 'Wrapped liquid staked Ether',
            symbol: 'wstETH',
            address: '0x84a600039E7C1169dA4aF41513763883D583fcC3',
            img: require('../assets/images/wsteth.webp'),
            decimals: 18,
        },
    },
    [Token.acp]: {
        [ChainId.mainnet]: {
            name: 'Arena Of Faith',
            symbol: 'ACP',
            address: '0x104e363ac6521e55a24ae724855362acec3febe6',
            img: require('../assets/images/acp.jpg'),
            decimals: 18,
        },
        [ChainId.metisMainnet]: {
            symbol: 'ACP',
            address: '0x4d0eBBE9A51E41F799abAdaEEB8Ab5197B99850a',
            img: require('../assets/images/acp.jpg'),
            name: 'Arena Of Faith',
            decimals: 18,
        },
    },
    [Token.bang]: {
        [ChainId.metisMainnet]: {
            name: 'BANG Token',
            symbol: 'BANG',
            address: '0x74CE2C404fc14C7b8e8E571c8E24a20c2bbaD9Ed',
            img: BangSvg,
            decimals: 18,
        },
        [ChainId.goatedMainnet]: {
            name: 'BANG Token',
            symbol: 'BANG',
            address: '0x326153ad128C97D502f88c8b0Da177C405c19AC0',
            img: BangSvg,
            decimals: 18,
            oft: true,
        },
    },
};

export const LidoTokenList = [Token.wsteth];
export const AcpTokenList = [Token.acp];
export const BangTokenList = [Token.bang];

export const TokenList = [
    Token.metis,
    Token.eth,
    Token.wbtc,
    Token.usdc,
    ...LidoTokenList,
    Token.usdt,
    Token.dai,
    ...AcpTokenList,
    Token.busd,
    Token.aave,
    // Token.crv,
    Token.link,
    // Token.uni,
    Token.sushi,
    Token.wow,
];

const GoatedTokenList = [Token.bang];

export const TestnetTokenList = [Token.metis, Token.eth];

export const TokenLists = {
    [`${ChainId.mainnet}_${ChainId.metisMainnet}`]: TokenList,
    [`${ChainId.metisMainnet}_${ChainId.goatedMainnet}`]: GoatedTokenList,
    [`${ChainId.metisMainnet}_${ChainId.mainnet}`]: TokenList,
    [`${ChainId.testnet}_${ChainId.metisTestnet}`]: TestnetTokenList,
    [`${ChainId.metisTestnet}_${ChainId.testnet}`]: TestnetTokenList,
    [`${ChainId.goatedMainnet}_${ChainId.metisMainnet}`]: GoatedTokenList,
};

export const RPC = {
    [ChainId.metisMainnet]: 'https://andromeda-rpc.metis.io',
    [ChainId.metisTestnet]: 'https://sepolia.metisdevops.link',
    [ChainId.mainnet]:
        'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    [ChainId.testnet]: 'https://rpc.sepolia.org',
};

export const METIS_MAINNET_EID = 30151;
export const GOAT_MAINNET_EID = 30361;
